import React, { useState, useEffect } from "react";
import "./Motivation.css"; // Para estilos personalizados, caso necessário

const phrases = [
  "Delante de la meta no puedo fallar",
  "Vivir, luchar, sufrir, vencer",
  "Nunca se apagará el brillo del barrio",
  "Sé que mi valor es más que oro y plata",
  "Cada lágrima que cae alimenta mi fe",
  "Soy aquel que no puede fallar",
  "La vida es un desafío, y cada quien elige su camino",
  "Si no tienes motivo para vivir, no busques motivo para morir",
  "La paz interior es lo que el hombre busca"
];

const Motivation = () => {
  const [phrase, setPhrase] = useState("");

  useEffect(() => {
    // Genera una frase aleatoria al cargar el componente
    setPhrase(phrases[Math.floor(Math.random() * phrases.length)]);
  }, []);

  return (
    <div className="motivation-container">
      <p className="motivation-phrase">"{phrase}"</p>
    </div>
  );
};

export default Motivation;
